import withRewardModalProps from 'viewModel/globalModals/rewardModal/withRewardModalProps';

import RewardModal from 'components/GlobalModals/RewardModal/RewardModal';

export default withRewardModalProps(RewardModal);
